import React, { useState,useEffect, useLayoutEffect } from "react";
//import Router from "router";
import { useHistory } from "react-router";
import "./header/Header.css"; 
import "../scss/general.css"
import Moment from "moment";
import BusyModal from "./modalwait";
import Cookies from "universal-cookie";
//import buttonlogo from "./images/go.jpg";

function Medicalapp() {
  const  axios = require("axios");
  const [Data,getValues] = useState({name:"",CBalance: 0,RBalance:0,SDate: "",EDate:"",bdisabled:false,myear:0});
  const [count, setCount] = useState(0);
  const [ErrMsg, setMesg] = useState("");
  const [BAmount, setBAmount] = useState(0);
  const [ErrMsg2, setErrMsg2] = useState("");
  const [ErrMsg_emp, setErrMsg_emp] = useState("");
  const [lindex,setlindex] = useState(0);
  const history = useHistory();
  const cookies = new Cookies();

//  const [inputList, setInputList] = useState([{PCode: "", PName: "", relation:"Self", cAmt:0, cDate:Moment(new Date()).format("YYYY/MM/DD"), mAmt:0, mDate:Moment(new Date()).format("YYYY/MM/DD"), tAmt:0, tDate:Moment(new Date()).format("YYYY/MM/DD"), Total:0}]);
  const [inputList, setInputList] = useState([{emp_id:"",PCode: "", PName: "", relation:"Self", cAmt:0, cDate:"", mAmt:0, mDate:"", tAmt:0, tDate:"", Total:0,myear:0}]);
  const [LoginID,setLoginID]= useState(cookies.get("LoginID"));
  const [applicant,setapplicant]=useState(cookies.get("LoginID"));
  const [bdisabled, setdisabled]=useState(false);
  useEffect(() => {
    if( count === 0)
    {   
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/medicalbalance/',
          data: applicant,
          headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
          document.body.style.cursor="default";
          console.log(response.data);

          const newValues = {name:"",CBalance: response.data[0]["Ceiling"], RBalance: response.data[0]["Remaining"],SDate:Moment(response.data[0]["DateStart"]).format("DD/MM/YYYY"),EDate: Moment(response.data[0]["DateEnd"]).format("DD/MM/YYYY"),myear:response.data[0]["tyear"]}
          //this.bdisabled=true;
          getValues(newValues);
      })
      .catch(function (response) {
        document.body.style.cursor="default";

      });      
    }
  }, []);

  const handleLoad=() => {
    if(applicant.length > 5)
    {   
      document.body.style.cursor ="wait";
      axios({
          method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/medicalbalanceother2/',
          data: applicant,
          headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
          const newValues = {name:"",CBalance: response.data[0]["Ceiling"], RBalance: response.data[0]["Remaining"],SDate:Moment(response.data[0]["DateStart"]).format("DD/MM/YYYY"),EDate: Moment(response.data[0]["DateEnd"]).format("DD/MM/YYYY"),myear:response.data[0]["tyear"]}
          setErrMsg_emp(response.data[0]["name"] + "( " + response.data[0]["desig"] +" )");
//          setdiv_e_d("none");
          getValues(newValues);
        document.body.style.cursor="default";

      })
      .catch(function(response) {
        document.body.style.cursor="default";
        setErrMsg_emp("Employee code not found.");

      });      
    }
    else
    {
      document.body.style.cursor="default";
      setErrMsg_emp("Employee code not entered.");
    }
    }

  // handle input change
  const handleInputChangeid = (e)=> {
    setapplicant(e.target.value);
  }

  const cur=(num)=> {
    let cnum=parseInt(num,0);
    if(cnum > 0)
        return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    else
        return "-"
  }
  const handleSubmit=()=>{
        if(Number(BAmount) > Data.RBalance)
          setMesg("You have not enough balance to proceed this bill.");
        else
        {
          document.body.style.cursor="wait";
          setMesg("");
          setErrMsg2(<BusyModal/>);

         axios({
           method: 'post',
          url: cookies.get("phpclass")+'/index.php/user/medicaldetail/',
          data: inputList,
          headers: {'Content-Type': 'multipart/form-data'}
          })
          .then((response)=> {
            document.body.style.cursor="default";
            if(response.data==="1")
            { 
              setErrMsg2("");
//              history.push('/MedicalClaimList');
              if(applicant === LoginID)
                {history.push('/MedicalDetailSelf');}
              else
              {history.push('/MedicalDetailother');}
              setdisabled(true);
            } 
            else
            {   
              setMesg("Some Error accoured, please try later.");
              setErrMsg2("");
              setdisabled(true);
            }
          })
          .catch(function (error) {
            document.body.style.cursor="default";
            setMesg("Some Error accoured, please try later.");
            setErrMsg2("");
            setdisabled(true);
        });
      }
  }
  // handle input change
  const handleInputChange1 = (e, index)=> {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    list[index]["PCode"]=applicant;    
    list[index]["emp_id"]=LoginID;
    list[index]["myear"]=Data.myear;
    setInputList(list);
    setCount(count + 1);
  }


  // handle input change
  const handleInputChange = (e, index)=> {

//    const sum = e.target.value.split('+').map(Number).reduce((acc, num) => acc + num, 0);

  //  alert(sum);
    setBAmount(Number(BAmount)+Number(e.target.value));
  }
  const handleFocus=(e)=> {e.target.select();
    if(Number(e.target.value) > 0)
      setBAmount(Number(BAmount)-Number(e.target.value));
  }

  // handle click event of the Remove button
  const handleRemoveClick = index => {
    const list = [...inputList];
    setBAmount(Number(BAmount)-list[index]["cAmt"]-list[index]["mAmt"]-list[index]["tAmt"]);
    list.splice(index, 1);
    setInputList(list);
  }

  // handle click event of the Add button
  const handleAddClick =() =>{
    setInputList([...inputList, { PName: "", relation:"Self", cAmt:0, cDate:"", mAmt:0, mDate:"", tAmt:0, tDate:"", Total:0,myear:0}]);

  }
  return (
      <div  width="50%" textAlign="center" >
        <br></br>
        <div style={{width:"100%",textAlign:"center"}}>

        <span className="box-title" >Medical Reimbursement Form</span>
        </div>
        <div className="inner-divm" >

      <div style={{textAlign:"center",width:"100%",marginTop:"10px"}}>

      <table style={{width:"85%",marginTop:"15px",paddingLeft:"0px",display:"block"}}>
        <thead></thead>
        <tbody>
          <tr >
            <td style={{width:"100px"}}>
              <input style={{width:"90px",padding:"2px"}}
              autoFocus="autofocus"
              name="EmpID"
              border="none"
              placeholder="Employee Id"
              onChange = {e =>  handleInputChangeid(e)}
            />
            </td>
            <td>
            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)"}} onClick={e => handleLoad()}>Go </button>                  

            </td>
            <td style={{textAlign:"left",width:"300px",fontWeight:"bold"}} >{ErrMsg_emp} </td>

          </tr>
        </tbody>
      </table>        
      <table className="mtable">
        <tbody>
    <tr>
          <td style={{width:"75px",fontStyle: "bold"}}>From:</td>
          <td style={{width:"100px",textAlign:"left"}}>{Data.SDate}</td>
          <td style={{width:"75px"}}>To:</td>
          <td style={{width:"100px",textAlign:"left" }}>{Data.EDate}</td>
        </tr>
        <tr>
          <td style={{width:"75px",fontStyle: "bold"}}>Ceiling:</td>
          <td style={{width:"100px",textAlign:"left"}}>{cur(Data.CBalance)}</td>
          <td style={{width:"75px"}}>Remaining:</td>
          <td style={{width:"100px",textAlign:"left" }}>{cur(Data.RBalance)}</td>
          <td style={{width:"75px",fontStyle: "bold"}}>Bill amount:</td>
          <td style={{width:"100px",textAlign:"left"}}>{cur(BAmount)}</td>
        </tr>
        </tbody>
      </table>
      
       {/* <h6>Ceiling: {Data.CBalance}   Remaining: {Data.RBalance}</h6>  */}
      <table className="mtable">
          <thead>
            <tr>
                <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>PATIENT NAME</p></th>
                <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>RELATION</p></th>
                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}> CONSULTATION</p></th>
                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>MEDICINES </p></th>
                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>TESTS/LAB.</p></th>
            </tr> 
            <tr>
              <th className="mth">Amount</th>
              <th className="mth">Date</th>
              <th className="mth">Amount</th>
              <th className="mth">Date</th>
              <th className="mth">Amount</th>
              <th className="mth">Date</th>
            </tr>
          </thead>
    <tbody>
    {inputList.map((x, i) => {
    return (
            <tr key={i}>
                <td className="mtd">
                    <input style={{width:175, border:'none'}}
                      autoFocus="autofocus"
                      name="PName"
		        	        placeholder="Patient Name"
                      value={x.PName}
                      onChange={e => handleInputChange1(e, i)}
                      onFocus={ e => handleFocus(e)}
                    />
                </td>
                <td className="mtd">
                    <select style={{width:80, border:'none'}}
                    value={x.relation} 
                    name="relation"
                    onChange={e => handleInputChange1(e, i)}
                    >
                    <option value="Self">Self</option>
                    <option value="Wife">Wife</option>
                    <option value="Daughter">Daughter</option>
                    <option value="Son">Son</option>
                    </select>
                </td>
                <td className="mtd">
                    <input type="number" style={{width:75, border:'none',textAlign: 'right' }}
                        name="cAmt"
                        value={x.cAmt}
                        onChange={e => handleInputChange1(e, i)}
                        onBlur={e => handleInputChange(e, i)}

                        onFocus={ e => handleFocus(e)}
                    />
                </td>
                <td className="mtd">
                    <input type="date" style={{width:120, border:'none'}}
                        name="cDate"
                        value={x.cDate}
                        onChange={e => handleInputChange1(e, i)}
                    />
                </td>
                <td className="mtd">
                    <input type="number" style={{width:75, border:'none',textAlign: 'right' }}
                        name="mAmt"
                        value={x.mAmt}
                        onChange={e => handleInputChange1(e, i)}
                        onBlur={e => handleInputChange(e, i)}

                        onFocus={ e => handleFocus(e)}
                        />
                </td>
                <td className="mtd">
                    <input type="date" style={{width:120, border:'none'}}
                        name="mDate"
                        value={x.mDate}
                        onChange={e => handleInputChange1(e, i)}
                    />
                </td>
                <td className="mtd">
                    <input type="number" style={{width:75, border:'none',textAlign: 'right' }}
                        name="tAmt"
                        value={x.tAmt}
                        onChange={e => handleInputChange1(e, i)}
                        onBlur={e => handleInputChange(e, i)}

                        onFocus={ e => handleFocus(e)}
                        />
                </td>
                <td className="mtd">
                    <input type="date" style={{width:120, border:'none'}}
                        name="tDate"
                        value={x.tDate}
                        onChange={e => handleInputChange1(e, i)}
                    />
                </td>
                <td style={{border:"none"}}>
                    {inputList.length !== 1 && <button
                        className="mr10"
                        onClick={() => handleRemoveClick(i)}>X</button>}
                </td>
                <td style= {{border:"none"}}>
                    {inputList.length - 1 === i && <button onClick={handleAddClick}>+</button>}
                </td>
            </tr>
      );
    })}

    </tbody>
  </table>

  </div>
    <div style={{width:"90%", height:"60px",textAlign:"center", marginTop:"20px"}} >
      <button  align="center" className="btn btn-secondary" disabled={bdisabled} onClick={handleSubmit}>Submit</button> 
       <p style={{color:"red",fontSize:"10pt"}}>{ErrMsg}</p>
       <p style={{color:"red",fontSize:"10pt"}}>{ErrMsg2}</p>

    </div>
</div>
</div>
);
}

export default Medicalapp;